import React from 'react';
import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const BaseInput = props => {
  const { t } = useTranslation();
  const {
    multiline,
    label,
    id,
    type,
    disabled,
    field: { name, value, onChange, onBlur },
    form: { touched, errors },
  } = props;
  const classes = useStyles();
  return (
    <TextField
      error={touched[name] && Boolean(errors[name])}
      helperText={touched[name] && t(errors[name])}
      label={label}
      variant="outlined"
      id={id}
      name={name}
      className={classes.field}
      type={type || 'text'}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      multiline={multiline}
      rows="4"
      disabled={disabled}
      FormHelperTextProps={{
        style: {
          marginLeft: 0,
        },
      }}
      InputProps={{
        style: {
          height: multiline ? '88px' : '40px',
        },
      }}
      InputLabelProps={{
        shrink: false,
      }}
    />
  );
};

BaseInput.propTypes = {
  multiline: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

BaseInput.defaultProps = {
  multiline: false,
  label: '',
  type: 'text',
  disabled: false,
  onChange: () => {},
  onBlur: () => {},
};

export default BaseInput;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/BaseInput/BaseInput.js